module.exports = __webpack_public_path__ + "static/media/ApplePayMark.4132ebc2.png";